import UserActions from "@/components/header/UserActions";
import { useNativeFloatingBubble } from "@/hooks/useNativeFloatingBubble";

const STORAGE_KEY = "bilenia-native-profile-pos";

/** Logged-in native: draggable floating profile control (no app header). */
const NativeFloatingProfile = () => {
  const { style, suppressClickRef, pointerHandlers } =
    useNativeFloatingBubble(STORAGE_KEY);

  return (
    <div
      className="native-floating-profile pointer-events-auto fixed z-[85] touch-none"
      style={style}
      {...pointerHandlers}
    >
      <UserActions floating suppressClick={suppressClickRef} />
    </div>
  );
};

export default NativeFloatingProfile;
